var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgDownloadsBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6666 0 0 -2.6666 -207.87 623.62)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.48,167.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-8.379 8.378c-0.578 0.579-1.517 0.579-2.095 3e-3l-33.162-33.159c-0.93-0.933-2.527-0.272-2.527 1.049v75.824c0 0.814-0.664 1.481-1.482 1.481h-11.851c-0.818 0-1.481-0.667-1.481-1.481v-75.824c0-1.321-1.597-1.982-2.53-1.049l-33.157 33.159c-0.581 0.576-1.517 0.576-2.094-3e-3l-8.383-8.378c-0.577-0.578-0.577-1.517 0-2.098l52.522-52.515c0.581-0.578 1.516-0.578 2.095 0l52.524 52.515c0.577 0.581 0.577 1.52 0 2.098"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.8,105.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-95.795c-0.818 0-1.482-0.664-1.482-1.481v-11.852c0-0.817 0.664-1.481 1.482-1.481h95.795c0.821 0 1.481 0.664 1.481 1.481v11.852c0 0.817-0.66 1.481-1.481 1.481"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadsBlkRgb);
export default __webpack_public_path__ + "static/media/Downloads_BLK_RGB.0acbec98211a1bdc50676627df55caa5.svg";
export { ForwardRef as ReactComponent };